export default __webpack_public_path__ + "static/media/onlineTestIcon.45e5d4d8.svg";